module.exports = __webpack_public_path__ + "img/lemon-right-5.2a86d693.png";